import * as React from "react";
import { Query } from "react-apollo";
import { Redirect, Link } from "react-router-dom";
import { Helmet } from "react-helmet";

import { DashboardQuery, dashboardQuery } from "../graphql/user";
import { loginUrl, userProfileUrl } from "../urls";
import { Button, Card, Message } from "../semantic-ui";
import ChallengeCard from "../challenge/ChallengeCard";
import GameCard from "../game/GameCard";

const DashboardPage = () => (
  <Query<DashboardQuery> query={dashboardQuery} fetchPolicy="cache-and-network">
    {({ data, loading, error, refetch }) => {
      if (loading) return <div>Loading...</div>;
      if (error) {
        return (
          <div>
            <strong>Error:</strong> {error.message}
          </div>
        );
      } else if (!data || !data.me) {
        return <Redirect push to={loginUrl} />;
      }
      const incomingChallenges = data.me.incomingChallenges.nodes;
      const gamesNeedingAction = data.me.gamesNeedingAction.nodes;
      const gamesWaiting = data.me.gamesWaiting.nodes;
      const finishedGames = data.me.finishedGames.nodes;
      const activeGames = gamesNeedingAction.concat(gamesWaiting);
      return (
        <div>
          <Helmet title="Dashboard" />
          <h1>Dashboard</h1>
          <Button as={Link} to={userProfileUrl(data.me.id)}>
            Open Your Profile
          </Button>
          {incomingChallenges.length === 0 ? null : (
            <>
              <h2>Received challenges</h2>
              <Card.Group itemsPerRow={3} stackable>
                {incomingChallenges.map((challenge) => (
                  <ChallengeCard
                    key={challenge.id}
                    challenge={challenge}
                    onChange={() => refetch()}
                  />
                ))}
              </Card.Group>
            </>
          )}
          <h2>Active games</h2>
          {activeGames.length === 0 ? (
            <Message info>
              <Message.Header>
                You don't have any active games right now.
              </Message.Header>
              <p>
                Open another user's page to send them a challenge. You can send
                someone a link to your own page to have them send you a
                challenge. Use the "Open Your Profile" button to get a link to
                your own page.
              </p>
            </Message>
          ) : (
            <Card.Group stackable>
              {activeGames.map((game) => (
                <GameCard key={game.id} game={game} />
              ))}
            </Card.Group>
          )}
          {finishedGames.length === 0 ? null : (
            <>
              <h2>Recently finished games</h2>
              <Card.Group stackable>
                {finishedGames.map((game) => (
                  <GameCard key={game.id} game={game} />
                ))}
              </Card.Group>
            </>
          )}
        </div>
      );
    }}
  </Query>
);

export default DashboardPage;
